import { useEffect, useState } from 'react';
import { getCallAvailability } from '../api/o2oCalls';

// One batch poll for all mounted person cards, not one request per card.
// This only refreshes visible UI; no background jobs or call-state writes.
const listeners = new Map();
let interval = null;
let pending = null;
let running = false;
const refresh = async () => {
  if (running || document.hidden || !listeners.size) return;
  running = true;
  const ids = [...listeners.keys()];
  try {
    for (let offset = 0; offset < ids.length; offset += 50) {
      const batch = ids.slice(offset, offset + 50);
      try {
        const rows = await getCallAvailability(batch);
        rows.forEach((row) => listeners.get(row.user_id)?.forEach((cb) => cb(row)));
      } catch (_) {
        // Never leave an actionable, stale "Call" button after a failed refresh.
        batch.forEach((id) => listeners.get(id)?.forEach((cb) => cb({ user_id: id })));
      }
    }
  } finally { running = false; }
};
const scheduleRefresh = () => {
  clearTimeout(pending);
  pending = setTimeout(refresh, 80);
};

export const useCallAvailability = (creatorId, enabled = true) => {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    setStatus(null);
    if (!creatorId || !enabled) return undefined;
    if (!listeners.has(creatorId)) listeners.set(creatorId, new Set());
    listeners.get(creatorId).add(setStatus);
    if (!interval) {
      interval = setInterval(refresh, 10000);
      window.addEventListener('focus', scheduleRefresh);
      document.addEventListener('visibilitychange', scheduleRefresh);
      window.addEventListener('nymia:o2o-state-changed', scheduleRefresh);
    }
    scheduleRefresh();
    return () => {
      listeners.get(creatorId)?.delete(setStatus);
      if (!listeners.get(creatorId)?.size) listeners.delete(creatorId);
      if (!listeners.size) {
        clearInterval(interval); interval = null;
        clearTimeout(pending);
        window.removeEventListener('focus', scheduleRefresh);
        document.removeEventListener('visibilitychange', scheduleRefresh);
        window.removeEventListener('nymia:o2o-state-changed', scheduleRefresh);
      }
    };
  }, [creatorId, enabled]);
  return status?.user_id === creatorId ? status : null;
};